module.exports = __webpack_public_path__ + "static/media/ilus-contact-footer.e4089b7c.svg";